import React, { useState, useCallback, useEffect } from 'react'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import FooterServices from '../../services/footer.service'
import Loading from 'custom/assets/loaders/Loading'
import { useModal } from 'react-modal-hook'
import Modal from '../../components/Modal/Modal'
import NeoButton from '../../components/NeoButton/NeoButton'
import { useHistory } from 'react-router-dom'
import { BUTTON_KEYS, SUPPORT_CENTER_FAQ_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function FAQ() {
  const history = useHistory()
  const [faqDetails, setFaqDetails] = useState([])
  const [message, setMessage] = useState('')
  const [isSubmitting, setSubmitting] = useState(false)
  const {t}=useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <h6 className='text-center'>{message}</h6>
        <div className='mt-4 col-6 mx-auto'>
          <NeoButton
            type='button'
            mode='newDesign'
            text={t(BUTTON_KEYS.CLOSE)}
            onClick={() => {
              hideModal()
              history.push('/dashboard')
            }}
          />
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    getFAQDetails()
  }, [])

  const getFAQDetails = useCallback(
    async (values) => {
      setSubmitting(true)
      try {
        const response = await FooterServices.getFAQDetails(values)
        if (response.status === 200) {
          setFaqDetails(response.data)
          setSubmitting(false)
        }
      } catch (err) {
        setMessage(err.data.message)
        //showModal()
        setSubmitting(false)
      }
    },
    [showModal],
  )

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='FAQ' showEmptySpace={true} keyPath={'FAQ'}>
      <div>
        <div className='heading-style'>{t(SUPPORT_CENTER_FAQ_KEYS.TITLE)}</div>
        {isSubmitting === true ? renderLoading() : <div />}
        {faqDetails.faqList !== undefined
          ? faqDetails.faqList.map((value, i) => (
              <QuestionCard key={i} question={value.question} answer={value.answer} />
            ))
          : null}
      </div>
    </LayoutWithOutAccountCard>
  )
}

function QuestionCard({ question, answer }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div>
      <div
        style={{
          borderRadius: '19px',
          boxShadow:
            'inset 0 -3px 8px 0 rgba(255, 255, 255, 0.82), inset 0 -6px 15px 0 #ffffff,0 6px 30px 0 rgba(204, 204, 204, 0.44)',
        }}
        className='cursor-pointer my-4 card shadow-sm'
        onClick={() => setExpanded(!expanded)}>
        <div className='card-body pt-4 pb-3'>
          <h6 className='font-weight-bold' style={{ fontSize: '13px' }}>
            {question}
          </h6>
          {expanded && (
            <p className='mt-4 text-justify' style={{ fontSize: '12px' }}>
              {answer}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
